export const GB_VersionName = "2025 Live";

/* Update these variables before posting a new client */
export const GB_VersionNum = "1.0";
export const GB_VersionDate = "2025-01-14";

/* Server URLs */
export const GB_LiveServerURL = "https://viptserver.azurewebsites.net";
export const GB_Live2024ServerURL = "https://vipt2024server.azurewebsites.net";
export const GB_BetaServerURL = "https://viptbetaserver.azurewebsites.net";
export const GB_Beta2024ServerURL = "https://vipt2024betaserver.azurewebsites.net";
export const GB_LocalhostServerURL = "http://localhost:80";

/* Module master IDs */
export const GB_GB = 0;
export const GB_SC = 1;
export const GB_DM = 2;

export const GB_DM_Banner = 0;
export const GB_3MC_2024 = 1;
export const GB_Original_2024 = 2;
export const GB_3MC_2023 = 3;
export const GB_Original_2023 = 4;
export const GB_3MC_2025 = 5;
export const GB_Original_2025 = 6;

/* Page IDs */
export const GBLoginFormPg = "GBLoginForm";
export const GBStartScreenFormPg = "GBStartScreenForm";

/* Colors (in Delphi hex) */
export const clNone = "$1FFFFFFF";
export const sex = {
    both: 0,
    male: 1,
    female: 2,
};
export const numSexes = sex.female;

export const hAlign = {
    left: 0,
    right: 1,
    center: 2,
};

export const text = {
    bold: 0,
    italic: 1,
    underline: 2,
};

export const language = {
    english: 1,
    french: 2,
    arabic: 3,
    spanish: 4,
    russian: 5,
    portuguese: 6,
    chinese: 7,
    indonesian: 8,
};

/* Pack table defaults */

export const packTableDefaults = {
    GBRowCount: 1,
    GBColCount: 1,
    GBFixedRows: 1,
    GBFixedCols: 1,
    tableData: {
        value: [],
    },
    RDec: [],
    MergedCells: [],
    LockedCells: [],
    FontColors: [],
    GBColWidths: [],
    GBCellComment: [],
    title: "",
    hasData: true,
    hasDeselectedIntervs: false,
    RowIds: [],
    MinAllowedVal: [],
    MaxAllowedVal: [],
    FontStyles: [],
    FontSizes: [],
    IndentRowText: [{ xoffset: 0, Value: false }],
    Alignments: [],
};
